import { useModifyMedicationLog } from "../hooks/useModifyMedicationLog";
import { MedicationReportModel } from "../../../services/api/types/medications/models/MedicationReportModel";
import AddNoteOrVoid from "ui/molecules/common/AddNoteOrVoid";
import { PermissionsEnums } from "../../../services/api/types/authorisation/enums/PermissionsEnums";
import { MedicationAdministrationStatusEnum } from "../../../services/api/types/medications/enums/MedicationAdministrationStatusEnum";

interface Props {
  medication: MedicationReportModel | null;
  onClose: () => void;
}

export default function ModifyMedicationLogForm({
  medication,
  onClose,
}: Props) {
  const {
    control,
    submit,
    isSubmitting,
    handleVoidMedicationLog,
    isVoidLoading,
  } = useModifyMedicationLog(medication, { onSuccess: onClose });

  const medicationLogVoided =
    medication?.status === MedicationAdministrationStatusEnum.VOIDED;

  return (
    <AddNoteOrVoid
      control={control}
      onClose={onClose}
      submit={submit}
      isSubmitting={isSubmitting}
      voidItem={handleVoidMedicationLog}
      isVoidLoading={isVoidLoading}
      requiredPermission={PermissionsEnums.VOID_MEDICATION_LOG}
      isItemAlreadyVoided={medicationLogVoided}
    />
  );
}
